
import styled from 'styled-components';
import backgroundImage from '../Assets/ContectUSS.jpg'; // Assuming webback.png is the correct filename and path
import { useNavigate } from 'react-router-dom';
import webdevelopment from '../Assets/frontcont.jpg';
import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

const Wrap4 = styled.div`
/* background-color: red; */
width: 100%;
height:100%;
padding: 0%;
margin:0%;
box-sizing: border-box;
`
const MobileAppImage = styled.img`
position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
  @media (max-width:600px){
  width:100%;
  height:220px;
}
@media (min-width:601px) and (max-width:1024px){
  width:100%;
  height:320px;
}
`
const PageContainer = styled.div`
  background-image: url(${backgroundImage});
  background-size: cover;
  background-position: center;
  height: 391px;
  width:100% ;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white; /* Text color */

  @media (max-width:600px) {
    width:100% ;
    height: 191px;
}
@media (min-width:601px) and (max-width:1024px) {
    width:100% ;
    height: 291px;
}
`;

const ContentWrapper = styled.div`
  text-align: center;
  position: absolute;
  color:black;
`;
const ContectHeader = styled.h1`
color:white;
font-size: 4rem;
margin-top:180px;
margin-left: 110px;
margin-bottom: 20px;
gap:30px;

@media (max-width:600px) {
    font-size: 2rem;
    margin-top:50px;
    margin-left: 50px;
}
@media (min-width:601px) and (max-width:1024px){
  
    margin-top:80px;
    
}


`
const Contectbutton1 = styled.button`
border: none;
background-color: red;
color:white;
padding:10px;
border-radius: 10px 10px 10px 10px;
font-size: 20px;
font-weight: bold;
cursor: pointer;
@media (max-width:600px) {
    font-size:10px;
    
}
`
const Contectbutton2 = styled.button`
margin-left: 20px;
border: none;
background-color: yellow;
color:black;
padding:10px;
border-radius: 10px 10px 10px 10px;
font-size: 20px;
font-weight: bold;
cursor:pointer;

@media (max-width:600px) {
    font-size:10px;
    
}
`
const ContanierHeadInp = styled.div`
width:100%;
height:770px;
box-sizing: border-box;
align-items: center;
justify-content: center;
/* background-color: yellow; */
display: flex;
gap:100px;

@media (max-width:600px) {
  width: 100%;
  height: auto;
  flex-direction: column;
  gap:0px;
}
@media (min-width:601px) and (max-width:1024px) {
  width: 100%;
  height: auto;
  flex-direction: column;
  gap:0px;
}

`
const ContanierText = styled.div`
width: 500px;
height: 680px;
/* background-color: #09ff00; */
/* margin: 60px; */
box-sizing: border-box;
margin-top:70px;
/* margin-left:135px; */

@media (max-width:600px) {
  width: 100%;
  height: auto;
  flex-direction: column;
  margin: 0px;
margin-top:20px;
text-align: center;
align-items: center;
padding: 20px;
margin-left:0px;
  
}
@media (min-width:601px) and (max-width:1024px) {
  width: 100%;
  max-width: 95%;
  height: auto;
  flex-direction: column;
  margin-right:20px;
margin-top:20px;
text-align: center;
margin: 0px;
align-items: center;
padding: 20px;
margin-left:10px;
margin-bottom: 10px;
  
}
`
const SForm = styled.form`
width: 450px;
height:600px;
box-sizing: border-box;
/* background-color: pink; */
align-items: center;
text-align: center;
margin-top: 150px;
background-color: white;
box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.2);
border: 1px solid black;
border-radius: 20px 20px 20px 20px;

@media (max-width:600px) {
  margin-top: 0%;
  width: 350px;
  margin: 40px;
height:580px;
}
@media (min-width:601px) and (max-width:1024px) {
  margin-top: 10px;
  width:100%;
  max-width: 85%;
  /* margin: 40px; */
height:auto;
padding-bottom: 40px;
}
`
const ContanierTextHead = styled.p`
font-size: 35px;
margin-left:20px;
@media (max-width:600px) {
  font-size: 26px;
  margin-left:0px;
}
@media (min-width:601px) and (max-width:1024px) {
  font-size: 30px;
  margin-left:0px;
}
`
const ContanierTextHead1 = styled.h1`
color: darkblue;
margin-top: 40px;
font-size: 45px;
@media (max-width:600px) {
  font-size: 26px;
}
@media (min-width:601px) and (max-width:1024px) {
  font-size: 30px;
  margin-left:0px;
}
;

`
const ContanierTextHead2 = styled.p`

margin-top: 20px;
font-size:23px;

@media (max-width:600px) {
  font-size: 15px;
}
`
const Contanier2TextHead2 = styled.p`

margin-top: 20px;
font-size:23px;
@media (max-width:600px) {
  font-size: 16px;
}
@media (min-width:601px) and (max-width:1024px) {
  font-size: 20px;
  margin-left:0px;
}

`
const ContanierTextHead3 = styled.h2`
margin-top:30px;
  
`
const Contanier3TextHead3 = styled.h1`
margin-top:30px;
@media (max-width:600px) {
  margin-top: 7px;
}
  
`

const Contanier4TextHead4 = styled.p`
  font-size: 27px;
  margin-top:20px;
  @media (max-width:600px) {
  font-size: 16px;
}
@media (min-width:601px) and (max-width:1024px) {
  font-size: 20px;
  margin-left:0px;
}
`
const MainContanier = styled.div`
  width:100%;
  height:350px;
  align-items: center;
  justify-content:center;
  box-sizing: border-box;
  /* background-color: blue; */
  gap:40px;
  display: flex;

  @media (max-width:600px) {
  width: 100%;
  height: auto;
  align-items: center;
  flex-direction: column;
  gap:0px;
}
 @media (min-width:601px) and (max-width:1024px) {
  width: 100%;
  height: auto;

  flex-direction: column;
  align-items: center;
  gap:10px;
  
}
`
const ChildContanier1 = styled.div`
  
width: 500px;
height:280px;
background-color: #f0b105;
margin: 10px;
/* margin-left: 60px; */
box-sizing: border-box;
border: solid 1px black;
border-radius: 20px 20px 20px 20px;
/* margin-left:40px; */
padding-left: 90px;
line-height: 50px;
padding-right: 90px;
box-shadow: 0 16px 24px rgba(0, 0, 0, 0.3);

@media (max-width:600px) {
  margin: 0%;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 0%;
  padding-right: 0%;
  width: 350px;
height:200px;
line-height: 30px;
padding:20px;
  
}
@media screen and (min-width:601px) and (max-width:1024px) {
  margin-left: 0%;
  align-items: center;
  margin-top:70px;
}


`
const ChildContanier2 = styled.div`
  
width: 500px;
height:280px;
background-color: #f0b105;
margin: 10px;
line-height: 40px;
border-radius: 20px 20px 20px 20px;
padding-left: 90px;
box-shadow: 0 16px 24px rgba(0, 0, 0, 0.3);
padding-right: 90px;
border: solid 1px black;
@media (max-width:600px) {
  margin-top: 20px;
  margin: 0%;
  margin-bottom: 20px;
  margin-left: 0%;
  padding-left: 0%;
  padding-right: 0%;
  width: 350px;
  height:200px;
  line-height: 30px;
padding:20px;
}
@media screen and (min-width:601px) and (max-width:1024px) {
  
  align-items: center;
  margin-bottom:70px;
}
`
const SFormControl = styled.div`
flex-direction:column ;
width: 100%;
height: auto;
display: flex;
text-align: left;
margin-top: 15px;
padding: 30px;
/* background-color: green; */
`
const SLabel = styled.label`
margin: 10px;
font-size:23px;
display:flex;

`


const SInput = styled.input`
width: 100%;
height:45px;
border-radius: 12px 12px 12px 12px;
font-size: 18px;
margin-bottom:20px;

padding-left:10px;
border: 1px solid #ccc;
  /* border-radius: 4px; */
  box-sizing: border-box;
  /* font-size: 16px; */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  @media (max-width:600px) {
    width: 100%;
    height:35px;
}
`
const SInput1 = styled.textarea`
width: 100%;
height:120px;
font-size:18px;
border-radius: 12px 12px 12px 12px;
/* width: 200px; */
  /* height: 400px; */
  padding: 0;
  border: 1px solid #ccc;
  /* border-radius: 4px; */
  box-sizing: border-box;
  /* font-size: 16px; */
  overflow-y: auto;
width: 100%;
padding: 10px;

`
const SFromBtton = styled.button`
  justify-content: center;
  align-items: center;
  border: none;
  background: red;
  color:white;
  padding:10px;
  font-size: 23px;
  align-items: center;
  padding-left: 40px;
  border: 1px solid black;
  padding-right:40px;
  border-radius: 15px 15px 15px 15px;
  cursor:pointer;
  /* border: 1px solid black; */
`
const Peera12 = styled.p`
color:red;
`

const ContactUs = () => {
  const navigation = useNavigate();
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    form.current.reset()
    emailjs
      .sendForm(
        'service_sf6fm35', // Service ID
        'template_m4sqqwk', // Template ID
        form.current,
        'gzXtCmAs8GemfKAxI' // User ID
      )
      .then(
        (result) => {
          console.log('Email successfully sent:', result.text);
          alert('Message sent successfully!');
          form.current.reset(); // Clear the form
        },
        (error) => {
          console.error('Failed to send the message:', error.text);
          alert('Failed to send the message, please try again.');
        }
      );
  };
  
  return (
    <>
      <Wrap4>
        <ContentWrapper>
          <ContectHeader data-aos="fade-down" data-aos-duration="3000"></ContectHeader>
          {/* <Contectbutton1 onClick={() => navigation("/")} data-aos="fade-right">HOME</Contectbutton1> */}
          {/* <Contectbutton2 onClick={() => navigation("/about")} data-aos="fade-left">ABOUT US</Contectbutton2> */}
        </ContentWrapper>
        {/* <PageContainer /> */}
        < MobileAppImage src={webdevelopment} alt='Background' />
        <ContanierHeadInp>
          <ContanierText>
            <ContanierTextHead data-aos="fade-right">CONTACT US</ContanierTextHead>
            <ContanierTextHead1 data-aos="fade-right">Get in Touch</ContanierTextHead1>
            <Contanier2TextHead2>Get in touch to dicsuss your employee wellbeing needs today. please give us a call, drop us an email or fill out the contect from and we will get back to you.</Contanier2TextHead2>

            <ContanierTextHead3 data-aos="fade-right">Visit Us:</ContanierTextHead3>
            <Contanier4TextHead4>Address: Hawali Ramyana Wali, Street No: 01, Kasur.</Contanier4TextHead4>
            <ContanierTextHead3 data-aos="fade-right">Mail Us:</ContanierTextHead3>
            <ContanierTextHead2>zu1529293@gmail.com</ContanierTextHead2>
            <ContanierTextHead3 data-aos="fade-right">Phone Us:</ContanierTextHead3>
            <Contanier4TextHead4>03036976170</Contanier4TextHead4>

          </ContanierText>

          <SForm ref={form} onSubmit={sendEmail}>
            <SFormControl>
              <SLabel>Name<Peera12>*</Peera12></SLabel>
              <SInput name="user_name" placeholder="Enter your name" required />

              <SLabel>Your Email<Peera12>*</Peera12></SLabel>
              <SInput
                type="email"
                name="user_email"
                placeholder="Enter your email"
                required
              />

              <SLabel>Your Message<Peera12>*</Peera12></SLabel>
              <SInput1
                name="message"
                placeholder="Type your message"
                maxLength="2000"
                required
              />
            </SFormControl>

            <SFromBtton type="submit">SEND</SFromBtton>
          </SForm>

        </ContanierHeadInp>

        <MainContanier>
          {/* data-aos="flip-left" */}
          <ChildContanier1 data-aos="flip-left" >
            <Contanier3TextHead3>Kasur:</Contanier3TextHead3>
            <Contanier4TextHead4>Address:  Hawali Ramyana Wali, Kasur</Contanier4TextHead4>
          </ChildContanier1>
          {/* data-aos="flip-right" */}
          <ChildContanier2 data-aos="flip-right">
            <Contanier3TextHead3>Pakistan:</Contanier3TextHead3>
            <Contanier4TextHead4>Address: Hawali Ramyana Wali, Street No: 01, Kasur.</Contanier4TextHead4>
          </ChildContanier2>
        </MainContanier>


      </Wrap4>

    </>

  );
};

export default ContactUs;














